(function () {
  var mm = document.getElementById('sb-mm');
  if (!mm) return;
  // Horizon's own drawer (details/summary) must never stay "open" behind our menu,
  // otherwise its icon keeps showing the X after closing or after going back.
  function resetDrawer() {
    document.querySelectorAll('header-drawer details').forEach(function (d) {
      d.classList.remove('menu-open');
      if (d.hasAttribute('open')) d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.menu-drawer--has-submenu-opened').forEach(function (el) { el.classList.remove('menu-drawer--has-submenu-opened'); });
    document.body.style.overflow = '';
  }
  function open(e) {
    if (window.innerWidth > 989) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    mm.classList.add('is-open');
    mm.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sb-mm-lock');
    setTimeout(resetDrawer, 0);
  }
  function close() {
    mm.classList.remove('is-open');
    mm.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sb-mm-lock');
    resetDrawer();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--menu, header-drawer summary')) open(e);
    if (e.target.closest('[data-sb-mm-close]')) close();
  }, true);
  mm.addEventListener('click', function (e) { if (e.target.closest('a')) close(); });
  mm.addEventListener('submit', function () { close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  // back/forward cache: page comes back exactly as it was left – reset it
  window.addEventListener('pageshow', close);
  window.addEventListener('pagehide', close);
  document.addEventListener('toggle', function (e) { if (e.target.matches && e.target.matches('header-drawer details') && e.target.open) setTimeout(resetDrawer, 0); }, true);
})();
